import * as Accordion from "@radix-ui/react-accordion";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useI18n } from "../i18n";

export default function Faq() {
    const { t } = useI18n();
    const FAQS = [
        { q: t.q1, a: t.a1, tid: "faq-item-1" },
        { q: t.q2, a: t.a2, tid: "faq-item-2" },
        { q: t.q3, a: t.a3, tid: "faq-item-3" },
        { q: t.q4, a: t.a4, tid: "faq-item-4" },
        { q: t.q5, a: t.a5, tid: "faq-item-5" },
    ];
    return (
        <section id="faq" className="relative scroll-mt-24 py-24 sm:py-32" data-testid="section-faq">
            <div className="mx-auto max-w-3xl px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 0.7 }}
                    className="mb-12 text-center"
                >
                    <p className="mb-3 font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-brand-violet">
                        FAQ
                    </p>
                    <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-5xl">
                        {t.fa} <span className="text-gradient">{t.fb}</span>
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.1 }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                >
                    <Accordion.Root type="single" collapsible className="space-y-3">
                        {FAQS.map((f) => (
                            <Accordion.Item
                                key={f.tid}
                                value={f.tid}
                                className="group overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl transition-colors duration-300 data-[state=open]:border-brand-violet/40"
                                data-testid={f.tid}
                            >
                                <Accordion.Header>
                                    <Accordion.Trigger className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-sm font-bold text-white sm:text-base">
                                        {f.q}
                                        <ChevronDown
                                            size={18}
                                            className="shrink-0 text-zinc-500 transition-transform duration-300 group-data-[state=open]:rotate-180 group-data-[state=open]:text-brand-violet"
                                        />
                                    </Accordion.Trigger>
                                </Accordion.Header>
                                <Accordion.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
                                    <p className="px-6 pb-6 text-sm leading-relaxed text-zinc-400">{f.a}</p>
                                </Accordion.Content>
                            </Accordion.Item>
                        ))}
                    </Accordion.Root>
                </motion.div>
            </div>
        </section>
    );
}
